import React from 'react';
import { Stack, Typography, Link, Box } from '@mui/material';
import useMobile from '@/hooks/useMobile';
import Iconify from '@/components/Iconify';
import useAnalyticsEvents from '@/hooks/useAnalyticsEvents';
import TicketCard from '../../templates/plus/sections/ticket/TicketCard';

export default function Fan2FanItem({ onClick, data }) {
  const { isMobile } = useMobile();
  const { secondaryMarketClick } = useAnalyticsEvents();

  const handleClick = () => {
    secondaryMarketClick();
    onClick();
  };

  return (
    <Box onClick={onClick} sx={{ mb: 2 }}>
      <TicketCard
        variant={'fan2fan'}
        styles={{
          '&:hover': {
            borderColor: (theme) => theme.palette.primary.palette[200],
            backgroundColor: (theme) => theme.palette.primary.palette[50],
          },
        }}
      >
        <TicketCard.Body>
          <TicketCard.Info
            title="Boletos de fan a fan"
            styles={{ width: '95%' }}
          >
            <Typography
              sx={{
                fontSize: isMobile ? '12px' : '14px',
                lineHeight: '130%',
                color: (theme) => theme.palette.text.disabled,
              }}
            >
              Adquiere boletos de otros fans de manera segura.
            </Typography>
          </TicketCard.Info>

          <TicketCard.Action
            styles={{
              width: '5%',
            }}
          >
            <Stack role="button" justifyContent="center" alignItems="center">
              <Iconify icon="ph:caret-right" />
            </Stack>
          </TicketCard.Action>
        </TicketCard.Body>
      </TicketCard>
    </Box>
  );
}
